import { createStore } from 'vuex';
import auth from '@/store/auth'

const store = new createStore({
    modules: {
        auth: auth,
    }
});

export default store
